import './Nav.css';
import { useContext } from 'react';

import FlowContext from '../context/FlowContext';

const Nav = () => {
    const flow = useContext(FlowContext);

    return (
        <div className="Nav">
            <button className="auth-button" onClick={() => flow.authentication()}>
                {!flow.user || (flow.user && !flow.user.addr)
                    ? "Log in with Blocto"
                    : flow.user && flow.user.addr
                        ? "Log out"
                        : null
                }
                {
                    flow.user && flow.user.loggedIn
                        ? <h1 className="user-address">{flow.user.addr}</h1>
                        : null
                }
            </button>
        </div>
    );
}

export default Nav;
